"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreSignedS3Object = exports.S3ItemReference = exports.S3ItemReferenceShareWithType = exports.S3ItemReferenceShareWithTypes = exports.S3ItemReferenceTypeLabelsAdminPortal = exports.S3ItemReferenceTypeLabels = exports.S3ItemReferenceType = exports.S3ItemReferenceTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.S3ItemReferenceTypes = [
    // commercial
    'placement', // 'Placement',
    'issue', // 'Issue',
    //orderImageTypes
    'dump_ticket', // 'Dump Ticket' uploaded by hauler...TODO unify with 'dumpTicket' below (only exists for wayste backwards compatibility),
    'dumpTicket', // 'Dump Ticket' (probably also used by commercial),
    'haulerPayable', // 'Invoice from Hauler',
    // customerFileTypes
    'taxExemptionForm', // 'Tax Exemption Form',
    'net30Form', // 'Net 30 Form',
    'businessCard', // 'Business Card',
    // haulerFileTypes
    'coi', // 'Certificate of Insurance',
    'coiOld', // 'Certificate of Insurance (Old)',
    'pricingSheet', // 'Pricing Sheet',
    'serviceArea', // 'Service Area',
    'indemnificationForm', // 'Indemnification Form',
    'st3', // 'ST-3',
    'w9', // 'W-9',
    'signableDocument', // 'Signable Document',`
    // and finally, other:
    'other',
];
exports.S3ItemReferenceType = typebox_1.Type.Union(exports.S3ItemReferenceTypes.map((val) => typebox_1.Type.Literal(val)));
exports.S3ItemReferenceTypeLabels = {
    placement: 'Placement',
    issue: 'Issue',
    dump_ticket: 'Dump Ticket',
    taxExemptionForm: 'Tax Exemption Form',
    net30Form: 'Net Term Form',
    businessCard: 'Business Card',
    coi: 'Certificate of Insurance',
    coiOld: 'Certificate of Insurance (Old)',
    indemnificationForm: 'Indemnification Form',
    st3: 'ST-3',
    w9: 'W-9',
    signableDocument: 'Signable Document',
    other: 'Other',
};
exports.S3ItemReferenceTypeLabelsAdminPortal = {
    ...exports.S3ItemReferenceTypeLabels,
    haulerPayable: 'Invoice from Hauler',
    pricingSheet: 'Pricing Sheet',
    serviceArea: 'Service Area',
    dump_ticket: 'Dump Ticket (Uploaded by Hauler)',
    dumpTicket: 'Dump Ticket',
};
exports.S3ItemReferenceShareWithTypes = ['wayste', 'sourgum-customer', 'admin-portal', 'wayste-customer'];
exports.S3ItemReferenceShareWithType = typebox_1.Type.Union(exports.S3ItemReferenceShareWithTypes.map((val) => typebox_1.Type.Literal(val)));
exports.S3ItemReference = typebox_1.Type.Object({
    bucket: typebox_1.Type.String(),
    key: typebox_1.Type.String(),
    region: typebox_1.Type.String(),
    type: typebox_1.Type.Optional(typebox_1.Type.Union([exports.S3ItemReferenceType, typebox_1.Type.String()])),
    note: typebox_1.Type.Optional(typebox_1.Type.String()),
    shareWith: typebox_1.Type.Optional(typebox_1.Type.Array(exports.S3ItemReferenceShareWithType)),
    timestamp: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    /**
     * @deprecated use shareWith instead
     */
    visibleToCustomer: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
exports.PreSignedS3Object = typebox_1.Type.Object({
    url: typebox_1.Type.String(),
    timestamp: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
});
//# sourceMappingURL=s3-item-reference.js.map